import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=6cd15ba7"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=6cd15ba7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports